import Button from '@components/atoms/ui-kit/button.tsx';
import Modal from '@components/atoms/modals/modal.tsx';
import { useTranslation } from 'react-i18next';
import Input from '@components/atoms/ui-kit/input.tsx';
import { useState } from 'react';

type Props = {
  show: boolean;
  onClose: () => void;
  replaceSpeakers: (value: string) => void;
};

const ChangeAllSpeakers = ({ show, onClose, replaceSpeakers }: Props) => {
  const { t } = useTranslation();
  const [newSpeaker, setNewSpeaker] = useState('');

  const handleChangeAllSpeaker = () => {
    replaceSpeakers(newSpeaker);
    onClose();
  };

  return (
    <Modal
      isOpen={show}
      onClose={onClose}
      size="small"
      title={t('update-speakers')}
      caption={t(
        'add-this-speaker-name-to-all-speakers-of-the-paragraphs-action-can-not-be-undone'
      )}
      footerActions={[
        <Button
          onClick={handleChangeAllSpeaker}
          label={t('update-speakers')}
          size={'small'}
          variant={'primary'}
        />
      ]}
    >
      <Input
        id="speaker"
        name="transcript-speaker-name"
        value={newSpeaker}
        onChange={e => {
          setNewSpeaker(e.target.value);
        }}
        placeholder={t('speaker-1')}
        size="small"
        className="w-full"
        autoComplete="on"
        autoFocus={true}
      />
    </Modal>
  );
};

export default ChangeAllSpeakers;
